<template>
  <section class="box">
    <h2 class="title is-3">Pending members</h2>
    <ul v-if="!loading">
      <li v-for="user in pendingMembers" class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <img :src="user.avatar_url + '&size=48'" class="mr-2 br-1"/>
          <p class="mr-2" :title="user.email">{{ user.name || user.email }}</p>
        </div>
        <div class="d-flex justify-content-end grow-1">
          <button class="button is-danger ml-2" @click="deny(user)">Deny</button>
          <button class="button is-success ml-2" @click="approve(user)">Approve</button>
        </div>
      </li>
    </ul>
    <p v-if="pendingMembers.length === 0 && !loading">No pending members!</p>

    <Loader v-if="loading"/>

  </section>
</template>

<script>
import Loader from './Loader.vue'

import store from '../store.js'

export default {
  name: 'GroupModeratorPane',
  components: {
    Loader,
  },
  props: {
    teamID: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
    }
  },
  mounted () {
    store.dispatch('fetchPendingMembers', { teamID: this.teamID })
  },
  computed: {
    pendingMembers () {
      return store.state.pendingMembers
    },
    loading () {
      return store.state.loadingMembers
    },
  },
  methods: {
    approve (user) {
      store.dispatch('approveUser', { teamID: this.teamID, user })
      .then(() =>
        store.commit('notify', { message: 'User approved', level: 'success' })
      )
    },
    deny (user) {
      store.dispatch('denyUser', { teamID: this.teamID, user })
      .then(() =>
        store.commit('notify', { message: 'User denied', level: 'warning' })
      )
    },
  }
}

</script>

<style lang="scss" scoped>
.title.team {
  margin-bottom: 0;
}

ul.team-list {
  margin-top: 5px;
}

a.title {
  color: #23c6c8;
}

a.title:not(:last-child) {
  margin-bottom: 0;
}

.spaced {
  margin-left: 5px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// GroupModeratorPane.vue?5101a0ef